/**
 *
 */
export class TouchPoint
{
	x:number;

	y:number;

	id:number;

	constructor(x:number, y:number, id:number)
	{
		this.x = x;
		this.y = y;
		this.id = id;
	}
}